import axios from "./axios";

export interface AccessUiModalRecord {
  id?: string;
  reason: string;
  title: string;
  message: string;
  confirmLabel?: string | null;
  cancelLabel?: string | null;
  showCancel: boolean;
  isBlocking: boolean;
  primaryCtaLabel?: string | null;
  primaryCtaUrl?: string | null;
  secondaryCtaLabel?: string | null;
  secondaryCtaUrl?: string | null;
  updatedAtUtc?: string;
}

export async function getAdminAccessUiModals(): Promise<AccessUiModalRecord[]> {
  try {
    const res = await axios.get("/admin/access-ui/modals");
    return Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    console.error("getAdminAccessUiModals error", error);
    return [];
  }
}

export async function upsertAdminAccessUiModal(payload: AccessUiModalRecord): Promise<{ success: boolean }> {
  try {
    const res = await axios.post("/admin/access-ui/modals", payload);
    return { success: Boolean(res.data?.success ?? true) };
  } catch (error) {
    console.error("upsertAdminAccessUiModal error", error);
    return { success: false };
  }
}

export async function deleteAdminAccessUiModal(reason: string): Promise<{ success: boolean }> {
  try {
    const res = await axios.delete(`/admin/access-ui/modals/${encodeURIComponent(reason)}`);
    return { success: Boolean(res.data?.success ?? true) };
  } catch (error) {
    console.error("deleteAdminAccessUiModal error", error);
    return { success: false };
  }
}
